import App from 'app/app.js';
import 'app/store/ContentStore.js';

function LtSelectionTemplateFieldCtrl($scope, $filter, ContentStore) {
  this.fieldData = null;
  this.LABEL = 'label';
  this.EXAMPLE = 'example';
  this.CHOICES = 'choices';
  this.selectionFieldType = {
    STRING: 'STRING',
    INT: 'INTEGER',
    CHOICES: 'CHOICES'
  };

  this.getFieldData = function () {
    return this.fieldData;
  };

  this.setFieldData = function (value) {
    this.fieldData = value;
  };

  this.getValidationData = function (formField) {
    var errorText = $filter('ltSelectionTemplateFieldTranslateFilter')(
      $scope.selectionTemplateField,
      $scope.templateName,
      'errorText'
    );
    var validations = [
      {
        field: formField,
        validation: 'required',
        msg: errorText,
        fieldName: $scope.selectionTemplateField.name,
        templateName: $scope.templateName
      }
    ];

    if ($scope.selectionTemplateField.type === this.selectionFieldType.INT) {
      validations = R.concat(validations, [
        {
          field: formField,
          validation: 'max',
          msg: errorText,
          fieldName: $scope.selectionTemplateField.name,
          templateName: $scope.templateName
        },
        {
          field: formField,
          validation: 'min',
          msg: errorText,
          fieldName: $scope.selectionTemplateField.name,
          templateName: $scope.templateName
        }
      ]);
    }
    return validations;
  };

  this.getTranslatedLabel = function () {
    return $filter('ltSelectionTemplateFieldTranslateFilter')(
      $scope.selectionTemplateField,
      $scope.templateName,
      'label'
    );
  };

  this.onFieldChanged = function () {
    $scope.onFieldChanged();
  };

  this.isFieldDataInvalid = function () {
    var invalid = false;
    if ($scope.nameFieldValidation === true) {
      invalid = !$filter('SpecialCharacterValidationFilter')(this.fieldData);
    }
    return invalid;
  };
}

App.controller('LtSelectionTemplateFieldCtrl', ['$scope', '$filter', 'ContentStore', LtSelectionTemplateFieldCtrl]);
